import React, { useEffect, useState, useRef } from "react";
import { Phone, Video, MessageCircle, Calendar, CreditCard, Receipt, Globe, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardHeader, CardContent, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Header } from "../components/ui/header";
import { Footer } from "../components/ui/footer";
import { money } from "../utilities/currency";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getAgentDisplayPicUrl, parseUntilObject } from "../utilities/conversions";
import { useSelector } from "react-redux";
import { RootState } from "../state/store";
import { BookingSelector } from "../components/ui/bookingmodal.tsx";
import DOMPurify from "dompurify";
import { CallModal } from "../components/ui/callmodal.jsx";
import { useQuery } from "@tanstack/react-query";
import AgentDetail from "../components/agentdetail.tsx";


/* --- Skill details modal --- */
function SkillModal({ skill, onClose }) {
    useEffect(() => {
        function onEsc(e) { if (e.key === 'Escape') onClose(); }
        window.addEventListener('keydown', onEsc);
        return () => window.removeEventListener('keydown', onEsc);
    }, [onClose]);

    if (!skill) return null;
    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl p-6 max-w-lg w-full relative" onClick={(e) => e.stopPropagation()}>
                <button aria-label="Lukk" onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
                    <X />
                </button>
                <h2 className="text-xl font-bold mb-3">{skill.label}</h2>
                {skill.image ? (
                    <img src={skill.image} alt={skill.label} className="w-full h-40 object-cover rounded-lg mb-4" />
                ) : null}
                <p className="text-gray-700 leading-relaxed">{skill.description}</p>
            </div>
        </div>
    );
}

/* --- Booking selector (Vipps-style) --- */


// const agent = {
//     name: "Victor Norman",
//     title: "Rådgiver – Bedriftsjuss",
//     image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=400&auto=format&fit=crop",
//     bio: `Praktisk, løsningsorientert rådgiver. 1000+ samtaler siden 2023. Spesialisert innen bedriftsjuss, restrukturering og bærekraftige forretningsstrategier. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec accumsan justo sed sapien vulputate, vitae suscipit felis pretium. Morbi in sodales metus. Vivamus sed justo ut metus vulputate bibendum. Curabitur posuere, leo sit amet finibus tincidunt, mi metus bibendum velit, sed laoreet enim risus id purus. Integer sagittis libero eu neque viverra, nec hendrerit nulla iaculis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec malesuada erat nec efficitur interdum. Nam id justo sit amet enim posuere gravida. Nulla facilisi. Suspendisse potenti. Donec pretium, lacus et tincidunt pretium, urna lacus laoreet justo, eget feugiat risus elit a nunc.`,
//     skills: [
//         { icon: <CreditCard size={18} />, label: "Bank og finansiering", image: "https://images.unsplash.com/photo-1565514027011-6c0b97ff1c2a?q=80&w=600&auto=format&fit=crop", description: "Rådgivning innen kredittvurdering, kapitalstruktur og finansieringsstrategier for små og mellomstore bedrifter." },
//         { icon: <Receipt size={18} />, label: "Insolvens og restrukturering", image: "https://images.unsplash.com/photo-1581090464777-7c8f9b4b1a6b?q=80&w=600&auto=format&fit=crop", description: "Veiledning i omstrukturering, konkursforebygging og gjeldsforhandlinger." },
//         { icon: <Globe size={18} />, label: "Bærekraft og klimarisiko", image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=600&auto=format&fit=crop", description: "Strategisk rådgivning om ESG, grønn finansiering og bærekraftige investeringer." },
//     ],
// };


type AgentProfilePageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}

const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};

export default function AgentProfilePage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: AgentProfilePageProps) {
    const [showBooking, setShowBooking] = useState(false);
    const [selectedSkill, setSelectedSkill] = useState(null);
    const [wallet, setWallet] = useState(0);
    const { agentId } = useParams<{ agentId: string }>();
    const [loading, setLoading] = useState(true);
    const client = useSelector((state: RootState) => state.client.client);
    const default_configs = client ? JSON.parse(client.default_configs) : null;
    const footer_settings = client ? JSON.parse(client.footer_settings) : "";

    const [agent, setAgent] = useState<any>(null);

    const [selectedAgent, setSelectedAgent] = useState<string | null>(null);
    const [minutePrice, setMinutePrice] = useState<string | null>(null);
    const [callStartupFee, setCallStartupFee] = useState<string | null>(null);
    const [showCallModal, setShowCallModal] = useState(false);
    const [webSocketConn, setWebSocketConn] = useState<WebSocket | null>(null);
    const webSocketRef = useRef<WebSocket | null>(null);

    const [type, setType] = useState<string>("audio");

    const [vippsAuthenticate, setVippsAuthenticate] = useState(false);
    const [walletAuthenticate, setWalletAuthenticate] = useState(false);
    const [stripeAuthenticate, setStripeAuthenticate] = useState(false);
    const [responseAgent, setResponseAgent] = useState(false);
    const [waitingAgentCheck, setWaitingAgentCheck] = useState(false);
    const [callResponseObj, setCallResponseObj] = useState<any>(null);
    const [waitingCallback, setWaitingCallback] = useState(false);
    const [waitingCallbackInfo, setWaitingCallbackInfo] = useState<any>(null);

    const fetchStatus = async (baseUrl: string) => {
        if (client) {
            const response = await axios.get(baseUrl + "/getAgentStatus", { params: { agent_uid: agent.uid } });
            return response.data.data; // [{ uid, call_status }]
        }
    };
    // --- React Query: poll only status ---
    const { data: status } = useQuery({
        queryKey: ["agent-status"],
        queryFn: () => fetchStatus(baseUrl),
        refetchInterval: 5000, // 5 sec poll
        enabled: !!agent, // only run if agent is loaded
    });
    const fetchCustomer = async () => {
        const response = await axios.get(baseUrl + "/getCustomerByUID", {
            params: { token: currentUser.token },
        });
        if (response.data && response.data.status === "OK") {
            return response.data.data.uid;
        }
        throw new Error("Failed to fetch customer");
    };
    const { data: customer_uid } = useQuery({
        queryKey: ["customer", currentUser?.token],
        queryFn: fetchCustomer,
        enabled: !!currentUser, // only run if logged in
    });

    // 🟢 2. Store latest customer_uid in a ref so WebSocket always uses current one
    const customerUidRef = useRef(customer_uid);

    useEffect(() => {
        customerUidRef.current = customer_uid;
    }, [customer_uid]);

    const reconnectTimeout = useRef<number | null>(null);

    const connectWebSocket = () => {
        try {
            const wsServer = baseUrl.includes("localhost")
                ? "ws://localhost:8013/echo"
                : "wss://chamcore.com/echo";

            const connection = new WebSocket(wsServer);

            connection.onopen = () => {
                console.log("✅ WebSocket connected");
                connection.send("Connection Established!");
            };

            connection.onmessage = (e) => {
                if (!e.data) return;

                const data = parseUntilObject(e.data);
                if (!data || !data.information) return;

                const latestCustomerUid = customerUidRef.current;

                // --- your logic ---
                if (data.type === "video_call") {
                    if (data.information.customer_id === latestCustomerUid && data.about === "rejected_call") {
                        setResponseAgent(true);
                        setWaitingAgentCheck(false);
                        setCallResponseObj({ title: "Anrop avvist av agent", message: "Samtalen avbrutt" });
                    } else if (data.information.customer_id === latestCustomerUid && data.about === "accepted_call") {
                        setWaitingAgentCheck(false);
                        setResponseAgent(false);
                        setCallResponseObj(null);
                        setShowCallModal(false);
                        window.open("/customer/one-to-one-video-call/" + data.call_history_id, "_blank");
                    } else if (data.information.customer_id === latestCustomerUid && data.about === "timeout_by_agent") {
                        setResponseAgent(true);
                        setWaitingAgentCheck(false);
                        setCallResponseObj({ title: "Tidsavbrudd", message: "Agenten tok ikke samtalen i tide." });
                        let formData = new FormData();
                        formData.append("call_id", data.call_history_id);
                        formData.append("token", currentUser.token);
                        formData.append("call_status", "missed");
                        axios.post(baseUrl + "/hangupCall", formData);
                    }
                } else if (data.type === "audio_call") {
                    if (data.information.customer_id === latestCustomerUid && data.about === "WebCall_rejected_by_agent") {
                        setResponseAgent(true);
                        setWaitingAgentCheck(false);
                        setCallResponseObj({
                            title: "Beklager at agenten avviste anropet ditt.",
                            message: "Av en eller annen grunn kunne ikke agenten ta imot samtalen din akkurat nå.",
                            more_info: { call_history_id: data.call_history_id },
                        });
                    } else if (data.information.customer_id === latestCustomerUid && data.about === "WebCall_accepted_call") {
                        setResponseAgent(false);
                        setWaitingAgentCheck(false);
                        setCallResponseObj(null);
                        setVippsAuthenticate(false);
                        setWalletAuthenticate(false);
                        setStripeAuthenticate(false);
                        setShowCallModal(false);
                        setTimeout(() => {
                            window.open("/customer/one-to-one-audio-call/" + data.call_history_id, "_blank");
                        }, 5000);
                    } else if (data.information.customer_id === latestCustomerUid && data.about === "WebCall_timeout_by_agent") {
                        setResponseAgent(true);
                        setWaitingAgentCheck(false);
                        setCallResponseObj({ title: "Tidsavbrudd", message: "Agenten tok ikke samtalen i tide." });
                        let formData = new FormData();
                        formData.append("call_id", data.call_history_id);
                        formData.append("token", currentUser.token);
                        formData.append("call_status", "missed");
                        axios.post(baseUrl + "/hangupCall", formData);
                    }
                }
            };

            connection.onclose = () => {
                console.log("⚠️ WebSocket closed, retrying in 2s...");
                reconnectTimeout.current = setTimeout(connectWebSocket, 100);
            };

            connection.onerror = (err) => {
                console.log("❌ WebSocket error:", err);
                connection.close();
            };

            // store the connection
            webSocketRef.current = connection;
            setWebSocketConn(connection);
        } catch (err) {
            console.error("WebSocket setup failed:", err);
        }
    };

    // initial connect
    useEffect(() => {
        connectWebSocket();
        return () => {
            if (webSocketConn) webSocketConn.close();
            if (reconnectTimeout.current) clearTimeout(reconnectTimeout.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseUrl]);

    // Reconnect on tab focus
    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //         if (!document.hidden) {
    //             console.log("🟢 Tab active — checking WebSocket...");
    //             if (webSocketConn) {
    //                 webSocketConn.close();
    //             }
    //             if (!webSocketConn || webSocketConn.readyState !== WebSocket.OPEN) {
    //                 connectWebSocket();
    //             }
    //         }
    //     };

    //     document.addEventListener("visibilitychange", handleVisibilityChange);
    //     return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    // }, [webSocketConn]);

    const handlePhoneClick = (
        uid: string,
        minute_price: number,
        call_startup_fee: string,
        agent_call_permission: string,
        type: string,
    ) => {
        if ((default_configs.WebRTC === "yes" && agent_call_permission === "web") || type === "video") {
            setSelectedAgent(uid);
            setMinutePrice(minute_price.toString());
            setCallStartupFee(call_startup_fee);
            setShowCallModal(true);
            setType(type);
            setResponseAgent(false);
        } else {
            window.location.href = `tel:${footer_settings.footer_phone}`;
        }
    };

    const fetchAgent = async () => {
        try {
            const response = await axios.get(baseUrl + `/getAgentByUID`, {
                params: { code: agentId, client_uid: client.uid },
            });

            if (response.data.status === "OK") {
                const agentData = response.data.data;

                // ✅ Ensure image URL
                agentData.image = getAgentDisplayPicUrl(agentData.display_pic, baseUrl);
                // ✅ Normalize skills (handles single number, string, or array)
                let skillIds = agentData.skills;
                if (!Array.isArray(skillIds)) {
                    skillIds = [skillIds];
                }

                // ✅ Filter matching skill objects
                agentData.skills = (agentData.skills_list || []).filter(s =>
                    skillIds.includes(String(s.skill_Id))
                );
                setAgent(agentData);
            } else {
                setAgent(null);
            }
        } catch (error) {
            console.error("Error fetching agent:", error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAgent();
    }, [agentId, client]);

    //cancel convert call to callback
    const handleCancelConvertCallToCallback = (call_id: string) => {
        setShowCallModal(false);
        var formData = new FormData();
        formData.append('call_id', call_id);
        axios.post(baseUrl + "/cancelWebCallPayment", formData);
    }

    //convert call to callback
    const handleConvertCallToCallback = async (call_id: string) => {
        var formData = new FormData();
        formData.append('call_id', call_id);
        const response = await axios.post(baseUrl + "/updateWebCallToCallback", formData);

        if (response.data && response.data.status === "OK") {
            var data = {
                call_history_id: call_id,
                about: "callback_initated_call",
                channel: "common_channel",
                type: 'audio_call',
            };
            const connection = webSocketConn;
            if (connection && connection.readyState === WebSocket.OPEN) {
                connection.send(JSON.stringify(data));
            }

            setWaitingCallback(true);
            setWaitingCallbackInfo({ send_callback_email: response.data.send_callback_email });
            setCallResponseObj(null);
            setResponseAgent(false);
        }
    }


    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])

    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            {loading ? (
                <div className="text-center py-20 text-gray-500 text-lg">
                    Loading agent details...
                </div>
            ) : !agent ? (
                <div className="text-center py-20 text-red-500 text-lg">
                    Agent not found
                </div>
            ) : (<div className="max-w-6xl mx-auto py-10 px-4">
                {agent.description && (
                    <AgentDetail agent={agent} client={client} currentUser={currentUser} baseUrl={baseUrl} handlePhoneClick={handlePhoneClick} setShowBooking={setShowBooking} onLoginClick={onLoginClick} />
                )}
                <CallModal
                    show={showCallModal}
                    onClose={() => setShowCallModal(false)}
                    baseUrl={baseUrl}
                    agent_uid={selectedAgent}
                    minutePrice={minutePrice}
                    currentUser={currentUser}
                    callStartupFee={callStartupFee}
                    webSocketConn={webSocketConn}
                    setWebSocketConn={setWebSocketConn}
                    webSocketRef={webSocketRef}
                    responseAgent={responseAgent}
                    setResponseAgent={setResponseAgent}
                    waitingAgentCheck={waitingAgentCheck}
                    setWaitingAgentCheck={setWaitingAgentCheck}
                    vippsAuthenticate={vippsAuthenticate}
                    setVippsAuthenticate={setVippsAuthenticate}
                    walletAuthenticate={walletAuthenticate}
                    setWalletAuthenticate={setWalletAuthenticate}
                    stripeAuthenticate={stripeAuthenticate}
                    setStripeAuthenticate={setStripeAuthenticate}
                    callResponseObj={callResponseObj}
                    setCallResponseObj={setCallResponseObj}
                    handleCancelConvertCallToCallback={handleCancelConvertCallToCallback}
                    handleConvertCallToCallback={handleConvertCallToCallback}
                    waitingCallback={waitingCallback}
                    waitingCallbackInfo={waitingCallbackInfo}
                    onLoginSuccess={onLoginSuccess}
                    type={type}
                />
                {showBooking && <BookingSelector agent={agent} onClose={() => setShowBooking(false)} baseUrl={baseUrl} client={client} currentUser={currentUser} onLoginSuccess={onLoginSuccess} />}
                {selectedSkill && <SkillModal skill={selectedSkill} onClose={() => setSelectedSkill(null)} />}
            </div>)}

            {/* Footer */}
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
